<form [formGroup]="effectenFg">

    <snelstart-ui-text-form-control formControlName="omschrijving"
                                    id="omschrijving"
                                    label="Omschrijving"
                                    class="me-1 custom-input-250"
    >
    </snelstart-ui-text-form-control>

    <snelstart-ui-number-form-control formControlName="bedrag"
                                      id="bedrag"
                                      label="Bedrag"
                                      [showAllDecimals]="false"
                                      align="right"
                                      [minValue]="1"
                                      prefix="€"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-select-form-control formControlName="soortEffecten"
                                      id="soortEffecten"
                                      label="Soort effecten"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsEffecten"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
</form>
